import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const FtpIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M12.03,8.8c0,.35-.28.62-.62.62h-.78v3.33c0,.35-.28.62-.62.62s-.62-.28-.62-.62v-3.33h-.78c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h2.81c.35,0,.62.28.62.62h0ZM6.66,8.18h-2.81c-.35,0-.62.28-.62.62v3.96c0,.35.28.62.62.62s.62-.28.62-.62v-1.36h1.21c.35,0,.62-.28.62-.62s-.28-.62-.62-.62h-1.21v-.73h2.19c.35,0,.62-.28.62-.62s-.28-.62-.62-.62ZM16.78,9.79c0,.89-.72,1.61-1.61,1.61h-1.2v1.36c0,.35-.28.62-.62.62s-.62-.28-.62-.62v-3.96c0-.35.28-.62.62-.62h1.82c.89,0,1.61.72,1.61,1.61h0ZM15.53,9.79c0-.2-.16-.36-.37-.37h-1.2v.73h1.2c.2,0,.36-.16.37-.37h0ZM20,6.36v9.26c0,1.37-1.11,2.48-2.48,2.48H2.48c-1.37,0-2.48-1.11-2.48-2.48V4.31C0,2.98,1.08,1.89,2.42,1.89h3.59c.17,0,.34.07.45.2l1.69,1.79h9.36c1.37,0,2.48,1.11,2.48,2.48h0ZM18.75,6.36c0-.68-.55-1.23-1.23-1.23H7.89c-.17,0-.34-.07-.45-.2l-1.69-1.79h-3.32c-.65,0-1.17.53-1.17,1.17v11.31c0,.68.55,1.23,1.23,1.23h15.03c.68,0,1.23-.55,1.23-1.23V6.36Z" />
 </svg>,
 "Ftp"
);
